// @flow strict

// $FlowFixMe[nonstrict-import]
import type {Dispatch, ThunkAction} from 'src/reducers';
import type {LeadRule} from 'src/types/landing-page.ts';
import type {
  ActiveJobsFilterColumnsData,
  FilterColumns,
} from 'src/types/discover';

// $FlowFixMe[nonstrict-import]
import {thunkify as flow} from 'src/utils/thunks';

// $FlowFixMe[nonstrict-import]
import * as reduxApi from 'src/utils/redux-api-bff';
import * as reduxApiV2 from 'src/utils/redux-api-v2';

// $FlowFixMe[untyped-import]
import {fetching, key} from 'src/utils/redux';


export const RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS =
  'discover-active-jobs/receive-active-jobs-table-columns';

type ReceiveActiveJobsTableColumnAction = {
  type: typeof RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS;
  payload: ActiveJobsFilterColumnsData;
};

export type DiscoverActiveJobsActions = ReceiveActiveJobsTableColumnAction;

const receiveActiveJobsTableColumnSelection = (
  payload: ActiveJobsFilterColumnsData,
): ReceiveActiveJobsTableColumnAction => ({
  type: RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS,
  payload,
});

export const getActiveJobsTableFilterColumn: () => ThunkAction<unknown> = flow(
  key(() => 'getActiveJobsTableFilterColumn'),
  fetching(),
)(() => async (dispatch: Dispatch) => {
  try {
    const payload: ActiveJobsFilterColumnsData = await dispatch(
      reduxApi.get('discover/jobs/configuration'),
    );
    dispatch(receiveActiveJobsTableColumnSelection(payload));
  } catch (error) {
    console.error('Error fetching all responses table column filter:', error);
  }
});

export const saveActiveJobsFilterColumns: (
  columnData: FilterColumns,
) => ThunkAction<unknown> = flow()(
  (columnData) => async (dispatch: Dispatch) =>
    dispatch(
      reduxApi.post('discover/jobs/configuration', {columns: columnData}, {}),
    ),
);

type EntityAttributesFieldStatsPayload = {
  entity_type: string;
  attributes: string[];
  categories: string[];
};

export const getEntityAttributesFieldStats: (
  payload: EntityAttributesFieldStatsPayload,
) => ThunkAction<unknown> = flow(
  key((payload) => {
    return `getEntityAttributesFieldStats:${payload.entity_type}`;
  }),
  fetching(),
)((payload) => async (dispatch: Dispatch) => {
  try {
    const response = await dispatch(
      reduxApi.post(`entity_attribute/fields/stats`, payload, {}),
    );
    return response;
  } catch (error) {
    console.error('Error fetching entity attributes field stats:', error);
    throw error;
  }
});

export const getActiveJobLogic: () => ThunkAction<unknown> = flow(
  key(() => 'getActiveJobLogic'),
  fetching(),
)(() => async (dispatch: Dispatch) => {
  try {
    const response = await dispatch(
      reduxApiV2.get(
        'job_match/active_job_logic',
        {},
        {
          apiPath: '/api/v1/',
        },
      ),
    );
    return response;
  } catch (error) {
    console.error('Error fetching active job logic:', error);
    throw error;
  }
});

type AudienceMembersCountPayload = {
  searchRule: LeadRule;
  entityType: string;
  preview: {
    columns: Array<{
      columnName: string;
      designation: string;
      label: string;
      relations: string[];
    }>;
  };
  searchText: string;
};

export const getAudienceMembersCount: (
  payload: AudienceMembersCountPayload,
) => ThunkAction<unknown> = flow(
  key(() => 'getAudienceMembersCount'),
  fetching(),
)((payload) => async (dispatch: Dispatch) => {
  try {
    const response = await dispatch(
      reduxApi.post('filter/preview-for-rule/count', payload, {}),
    );
    return response;
  } catch (error) {
    console.error('Error fetching audience members count:', error);
    throw error;
  }
});

export const getAudienceMembers: (
  payload: AudienceMembersCountPayload,
) => ThunkAction<unknown> = flow(
  key(() => 'getAudienceMembers'),
  fetching(),
)((payload) => async (dispatch: Dispatch) => {
  try {
    const response = await dispatch(
      reduxApi.post('filter/preview-for-rule', payload, {}),
    );
    return response;
  } catch (error) {
    console.error('Error fetching audience members:', error);
    throw error;
  }
});
